import {isAdmin, isSelectiveAiDomains} from 'common/HelperFunctions'
import Spinner from 'common/components/Spinner'
import {AiCreditType} from 'common/hooks/useAiCredits'
import {useState} from 'react'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {getAccessToken} from 'setup/redux/Actions/Timetable/timetable'

import {getTheme} from '_metronic/partials'

const SidebarAiCredits = () => {
  const dispatch = useDispatch()

  const [isViewingAiCreditsUsage, setIsViewingAiCreditsUsage] = useState(false)

  const aiCredits = useSelector<RootState>(
    ({userReducer}) => userReducer.aiCredits,
    shallowEqual
  ) as AiCreditType | null

  if (!isSelectiveAiDomains() || !isAdmin()) return null

  const remainingCredits =
    aiCredits?.remaining_credits !== null && aiCredits?.remaining_credits !== undefined
      ? aiCredits.remaining_credits.toLocaleString()
      : '0'

  const handleGetAccessToken = () => {
    if (isViewingAiCreditsUsage) return
    setIsViewingAiCreditsUsage(true)
    dispatch(
      getAccessToken(
        (response: any) => {
          setIsViewingAiCreditsUsage(false)
          const {accessToken, urdd_id} = response.result || response

          if (accessToken && urdd_id) {
            const aiCreditsUrl = window.location.hostname.includes('da1timetable.info')
              ? 'https://dev-subscription.ilmversity.ai/ai-credits'
              : import.meta.env.VITE_APP_AI_CREDITS_URL

            if (aiCreditsUrl) {
              try {
                const sourceDomain = window.location.hostname
                const theme = getTheme()
                const returnTo = window.location.href
                const aiCreditsUrlWithParams = `${aiCreditsUrl.replace(
                  /\/$/,
                  ''
                )}?accessToken=${encodeURIComponent(accessToken)}&urdd_id=${encodeURIComponent(
                  urdd_id
                )}&sourceDomain=${encodeURIComponent(sourceDomain)}&theme=${encodeURIComponent(
                  theme
                )}&returnTo=${encodeURIComponent(returnTo)}`

                window.location.href = aiCreditsUrlWithParams
              } catch (err) {
                console.error('Failed to open AI Credits:', err)
              }
            } else {
              console.error('VITE_APP_AI_CREDITS_URL environment variable not configured')
            }
          } else {
            console.error('AccessToken not found in response')
          }
        },
        (error: any) => {
          setIsViewingAiCreditsUsage(false)
          console.error('API Error:', error)
          console.error('Failed to get access token:', error.message || 'API call failed')
        }
      )
    )
  }

  return (
    <div
      id='kt_app_sidebar_ai_credits'
      className='app-sidebar-ai-credits flex-shrink-0 mx-3 mb-4 p-4 rounded bg-gray-100'
    >
      <div className='d-flex align-items-center justify-content-between mb-1'>
        <span className='fw-semibold fs-7 text-gray-600 app-sidebar-minimize-d-none'>
          AI Credits
        </span>
        <i className='fa-solid fa-coins text-warning fs-3' aria-hidden />
      </div>
      {/* Wrapper carries the minimize-hide toggle so the inner h2 (block) and button (flex)
          keep their own display when the collapsed sidebar is revealed on hover. Applying the
          toggle directly to them forces `display: initial` (inline), collapsing them onto one
          line — see .app-sidebar-minimize-d-none hover rule in _sidebar.scss. */}
      <div className='app-sidebar-minimize-d-none'>
        <h2 className='fw-bolder text-gray-900 mb-2'>{remainingCredits}</h2>
        <button
          type='button'
          onClick={handleGetAccessToken}
          disabled={isViewingAiCreditsUsage}
          className='btn btn-link p-0 d-flex align-items-center gap-1 fw-bold fs-7 text-primary'
        >
          {isViewingAiCreditsUsage ? (
            <>
              <Spinner size='sm' type='border' className='flex-shrink-0' />
              <span>View Details</span>
            </>
          ) : (
            <>
              <span>View Details</span>
              <i className='fa-solid fa-arrow-right fs-8' aria-hidden />
            </>
          )}
        </button>
      </div>
    </div>
  )
}

export {SidebarAiCredits}
